class UserAPIService {
  constructor() {
    if (new.target === UserAPIService) {
      throw new Error("Cannot instantiate an abstract class.");
    }
    if (this.login === UserAPIService.prototype.login) {
      throw new Error("Class extending UserAPIService must override 'login(data)'.");
    }
    if (this.register === UserAPIService.prototype.register) {
      throw new Error("Class extending UserAPIService must override 'register(data)'.");
    }
    if (this.getUser === UserAPIService.prototype.getUser) {
      throw new Error("Class extending UserAPIService must override 'getUser(data)'.");
    }
    if (this.validateOtp === UserAPIService.prototype.validateOtp) {
      throw new Error("Class extending UserAPIService must override 'validateOtp(data)'.");
    }
    if (this.sendOTP === UserAPIService.prototype.sendOTP) {
      throw new Error("Class extending UserAPIService must override 'sendOTP(data)'.");
    }
    if (this.validateOTP === UserAPIService.prototype.validateOTP) {
      throw new Error("Class extending UserAPIService must override 'validateOTP(data)'.");
    }
    if (this.updateProfile === UserAPIService.prototype.updateProfile) {
      throw new Error("Class extending UserAPIService must override 'updateProfile(data)'.");
    }
    if (this.userChangePassword === UserAPIService.prototype.userChangePassword) {
      throw new Error("Class extending UserAPIService must override 'userChangePassword(data)'.");
    }
    if (this.userSendContactUs === UserAPIService.prototype.userSendContactUs) {
      throw new Error("Class extending UserAPIService must override 'userSendContactUs(data)'.");
    }
    if (this.userSendFeedBack === UserAPIService.prototype.userSendFeedBack) {
      throw new Error("Class extending UserAPIService must override 'userSendFeedBack(data)'.");
    }
    if (this.userSendPublicContactUs === UserAPIService.prototype.userSendPublicContactUs) {
      throw new Error("Class extending UserAPIService must override 'userSendPublicContactUs(data)'.");
    }
  }

  async login(data) {
    throw new Error("Method 'login(data)' must be implemented.");
  }

  async register(data) {
    throw new Error("Method 'register(data)' must be implemented.");
  }

  async getUser() {
    throw new Error("Method 'getUser()' must be implemented.");
  }

  async validateOtp(data) {
    throw new Error("Method 'validateOtp(data)' must be implemented.");
  }

  async resendOtp(data) {
    throw new Error("Method 'resendOtp(data)' must be implemented.");
  }

  async sendOTP(data) {
    throw new Error("Method 'sendOTP(data)' must be implemented.");
  }

  async validateOTP(data) {
    throw new Error("Method 'validateOTP(data)' must be implemented.");
  }

  async updateProfile(data) {
    throw new Error("Method 'updateProfile(data)' must be implemented.");
  }

  async userChangePassword(data) {
    throw new Error("Method 'userChangePassword(data)' must be implemented.");
  }

  async userSendContactUs(data) {
    throw new Error("Method 'userSendContactUs(data)' must be implemented.");
  }

  async userSendFeedBack(data) {
    throw new Error("Method 'userSendFeedBack(data)' must be implemented.");
  }

  async userSendPublicContactUs(data) {
    throw new Error("Method 'userSendPublicContactUs(data)' must be implemented.");
  }
}

export default UserAPIService;
